module.exports = __webpack_public_path__ + "static/media/loc2_img3.2be59d8a.jpg";